export enum AlertMessageType {
  INFO,
  WARNING,
}
export class AlertMessage {
  constructor(
    public label: string,
    public type: AlertMessageType,
    public actionRoute?: string | undefined
  ) {}
}
